import React from "react";
import {
  ShieldCheck,
  Server,
  Cloud,
  Laptop2,
  Monitor,
  Building2
} from "lucide-react";

const services = [
  {
    title: "Infrastructure Management",
    icon: <Server className="w-8 h-8 text-blue-500" />,
    desc:<ul className="list-disc list-inside text-black text-base font-poppins space-y-1">
          <li>Server Management</li>
          <li>Mail Management</li>
          <li>LAN and WAN Management</li>
          <li>Datacenter Solutions</li>
          <li>Backup Management</li>
          <li>Disaster Recovery solutions</li>
         </ul>
  },
  {
    title: "IT Hardware Deployment Services",
    icon: <Monitor className="w-8 h-8 text-blue-500" />,
    desc: <ul className="list-disc list-inside text-black text-base font-poppins space-y-1">
              <li>Procurement of desktops, laptops, servers, and IT peripherals</li>
              <li>Provide solutions based on business requirements</li>
              <li>Partnerships with trusted OEMs for quality assurance</li>
              <li>Expert consultation on configuration and compatibility</li>
              <li>Post-sales support and warranty handling</li>
            </ul>

  },
  {
    title: "Network Security & IT Support",
    icon: <ShieldCheck className="w-8 h-8 text-blue-500" />,
    desc: <ul className="list-disc list-inside text-black text-base font-poppins space-y-1">
           <li>Onsite IT Support</li>
           <li>Firewall,Network Security Implementation</li>
           <li>Data Backup & Recovery Support</li>
           <li>Network Setup & Maintenance</li>
          </ul>
  },
  {
    title: "Desktop & Laptop Rental",
    icon: <Laptop2 className="w-8 h-8 text-blue-500" />,
    desc: <ul className="list-disc list-inside text-black text-base font-poppins space-y-1">
          <li>Latest Models & Configurations</li>
          <li>Flexible Rental Plans</li>
          <li>Pre-Configured Devices</li>
          <li>Ongoing Support & Maintenance</li>
          <li>Doorstep Delivery & Pickup</li>
         </ul>
  },
  {
    title: "Facility Management Services",
    icon: <Building2 className="w-8 h-8 text-blue-500" />,
    desc:<ul className="list-disc list-inside text-black text-base font-poppins space-y-1">
          <li>Asset Management</li>
          <li>Helpdesk Management</li>
          <li>Vendor Management</li>
          <li>L1/L2 IT support</li>
        </ul>
  },
  {
    title: "Cloud Solutions",
    icon: <Cloud className="w-8 h-8 text-blue-500" />,
    desc: <ul className="list-disc list-inside text-black text-base font-poppins space-y-1">
          <li>Cloud Services</li>
          <li>Cloud Storage & Backup</li>
          <li>Cloud Security & Compliance</li>
        </ul>
  },
];

const OurServices = () => {
  return (
    <section id="services" className="relative overflow-hidden bg-white">
      {/* 🔹 Background Video Layer */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover z-0 "
      >
        <source src="/services-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* 🔹 Overlay to slightly darken the video */}
      <div className="absolute inset-0 z-10"></div>

      {/* 🔹 Foreground Content Layer */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 sm:px-10 lg:px-20 py-20 flex flex-col md:flex-row items-start">
        {/* Left Content */}
        <div className="w-full md:w-1/2">
          {/* Heading */}
          <div className="mb-10 text-left" data-aos="fade-up">
            <h2 className="text-3xl sm:text-4xl font-bold font-poppins text-white mb-4">
              Our <span className="text-sky-400 text-5xl">Services</span>
            </h2>
            <p className="text-white text-base sm:text-2xl font-roboto max-w-3xl">
              We offer a wide range of IT services designed to help your business succeed in a digital-first world.
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md p-6 text-left hover:shadow-xl transition-shadow duration-300"
                data-aos="fade-up"
              >
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold font-poppins text-black">
                  {service.title}
                </h3>
                <div className="text-gray-700 mt-2 font-montserrat" >{service.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
